import "./another.css";
import "../index.css";

import "../component/Navbar.js";
import "../component/Header.js";

import "../component/fixConsoleLog.js";
import "../component/displayBalance.js";
import "../component/checkAuth.js";
import {
  showAlert,
  safeFetch
} from "../component/functionFromExport.js";
import { setImageSrc, resetErrorField } from "../component/domHelpers.js";
import {
  getStoredPhone,
  getChatId,
  getWebApp,
  getSupportBotLink,
  openExternalLink,
  loadRuntimeConfig,
} from "../component/clientState.js";
import { showOverlay, hideOverlay } from "../component/uiFeedback.js";

import autosize from "/node_modules/autosize/src/autosize.js";

import chevronRight from "../image/chevron-right.svg";
//import creditCard from "../image/credit-card-2-back.svg";
import insta from "../image/instagram.svg";
import youtube from "../image/youtube.svg";
import vk from "../image/vk.svg";
import telegram from "../image/telegram.svg";
import closeCross from "../image/Union.svg";
import threeDots from "../image/three-dots-1.svg";
import chatDots from "../image/chat-dots-1.svg";
import closeCrossRed from "../image/Subtract.svg";
import gift from "../image/gift.svg";
import mortarboard from "../image/mortarboard-white.svg";
// import rulesIcon from "../image/rules-icon.svg";

// import { send } from "process";

[
  ["threeDotsIcon", threeDots],
  ["chevronRight", chevronRight],
  ["mortaTeacher", mortarboard],
  ["insta", insta],
  ["youtube", youtube],
  ["vk", vk],
  ["telegram", telegram],
  ["chatDots", chatDots],
  ["closeErrorBackButton", closeCross],
  ["gift", gift],
  ["referralHeroGift", gift],
].forEach(([id, src]) => setImageSrc(id, src));

const WebApp = getWebApp();
WebApp?.BackButton?.hide?.();
const chatId = getChatId();
//let chatId = "456072370";

const showPopUpPromoButton = document.querySelector(".fieldPromo");
const popUpPromo = document.getElementById("referrerPromo");

const closePromoButton = document.getElementById("closePromoButton");
setImageSrc("closePromoButton", closeCross);

let storageClientPhone = getStoredPhone();
//const frame = document.getElementById("rules-frame");

let clientYcId = "";
let botUser = "";

let sendClient;

const toSearch = location.search;

// if (storageClientPhone != 'n/a' && (storageClientPhone != undefined || storageClientPhone != null)) {
//   frame.style.height = `${window.innerHeight - 120}px`;
//   frame.style.borderRadius = '30px 30px 0 0';
// } else {
//   frame.style.height = `${window.innerHeight - 50}px`;
// }

safeFetch(`/search${toSearch}`)
  .then((responce) => responce.json())
  .then((data) => {
    if (data.responce) {
      showFourthMain.click();
      history.pushState({}, '', location.pathname);
    }
  })
  .catch((error) => {
    console.error(error);
  });

const loadClientData = (payload) =>
  safeFetch("/client", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  }).then((response) => response.json());

if (storageClientPhone) {
  setTimeout(() => {
    loadClientData({ clientPhone: storageClientPhone, chatId })
      .then((data) => {
        sendClient = data;
        clientYcId = data[0].client_yc_id;
        botUser = data[1];
        console.info(botUser);
      })
      .catch((error) => {
        console.error(error);
      });
  }, 200);
} else {
  setTimeout(() => {
    loadClientData({ chatId })
      .then((data) => {
        botUser = data[0];
        console.info(botUser);
      })
      .catch((error) => {
        console.error(error);
      });
  }, 200);
}

showPopUpPromoButton.addEventListener("click", () => {
  const getUrl = `/itemsMetrika?location=another&object=open_bonus_input&client_id=${clientYcId}`;
  safeFetch(getUrl);
  popUpPromo.style.display = "flex";
});

popUpPromo.addEventListener("click", (e) => {
  if (e.target.id === "referrerPromo") {
    popUpPromo.style.display = "none";
  }
});

closePromoButton.addEventListener("click", () => {
  popUpPromo.style.display = "none";
});

//const innerPromoBanners = document.querySelector(".innerPromo");

// safeFetch("/banners")
//   .then((res) => res.json())
//   .then((data) => {
//     displayBanners(data);
//   });

const displayBanners = (data) => {
  let innerP = "";
  data.forEach(({ name, src, about, button }, index) => {
    if (about === null) {
      innerP = "";
    } else {
      innerP = `<p class="tooltip">${about}</p>`;
    }

    let innerButton = "";
    if (button !== undefined) {
      innerButton = `<a href=${button.url} target=${button.target}><button class="smallBtn">${button.name}</button></a>`;
    }

    innerPromoBanners.innerHTML += `
    <div class="slide" style="background-image: url('${src}');">
    <h2 class="h3Ower">${name}</h2>
    ${innerP}
    <!-- ${innerButton} -->
  </div>`;
  });
};

//const openPromoMore = document.getElementById("pickPromo");
const firstFieldMain = document.getElementById("firstMain");
//const secondFieldMain = document.getElementById("secondMain");

// openPromoMore.addEventListener("click", () => {
//   WebApp.BackButton.show();
//   firstFieldMain.classList.add("classHide");
//  // secondFieldMain.classList.remove("classHide");
// });

const goToCatalog = document.getElementById("pickTeacherPage");

goToCatalog.addEventListener("click", () => {
  window.location.href = "/teacher";
  WebApp?.BackButton.show?.();
})

// центральная обработка BackButton будет установлена после инициализации экранов

const openRefProgram = document.getElementById("pickRefProgram");
const thirdFieldMain = document.getElementById("thirdMain");

openRefProgram.addEventListener("click", () => {
  if (storageClientPhone == null || storageClientPhone == "n/a") {
    window.location.href = "/auth";
  } else {
    WebApp?.BackButton.show?.();
    firstFieldMain.classList.add("classHide");
    thirdFieldMain.classList.remove("classHide");
  }
});

const referralDetailsLink = document.getElementById("referralDetails");
if (referralDetailsLink) {
  referralDetailsLink.addEventListener("click", (e) => {
    e.preventDefault();
    openExternalLink(referralDetailsLink.href);
  });
}

const activPromo = document.getElementById("activationPromoBtn");
const fieldPromo = document.querySelector(".MyInput");

const errMessage = document.getElementById("errMessBonus");

fieldPromo.addEventListener("focus", () => {
  resetErrorField(fieldPromo, errMessage);
});

const displayPreloader = document.querySelector(".preloader");
const getReferrerPromo = document.getElementById("referrerPromo");
const getMainClass = document.querySelector(".main");

activPromo.addEventListener("click", () => {
  const getUrl = `/itemsMetrika?location=schedule&object=activate_promo&promocode=${fieldPromo.value}&client_id=${clientYcId}`;
  safeFetch(getUrl);

  if (fieldPromo.value.length < 1) {
    errMessage.innerText = "Обязательное поле";
    fieldPromo.style.border = "1px solid red";
    return;
  }

  showOverlay(displayPreloader, [getReferrerPromo, getMainClass]);

  safeFetch("/promo", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ promo: fieldPromo.value, client: clientYcId }),
  })
    .then((response) => response.json())
    .then((data) => {
      hideOverlay(displayPreloader, [getReferrerPromo, getMainClass]);
      if (data.status === 404) {
        errMessage.innerText = "Неверный код";
        fieldPromo.style.border = "1px solid red";
      }
      if (data.status === 409) {
        errMessage.innerText = "Промокод уже активирован";
        fieldPromo.style.border = "1px solid red";
      }
      if (data.status === 200) {
        fieldPromo.value = "";
        popUpPromo.style.display = "none";
        showAlert("Промокод активирован");
      }
    })
    .catch((error) => {
      console.error(error);
      hideOverlay(displayPreloader, [getReferrerPromo, getMainClass]);
    });
});


const fourthMain = document.getElementById("fourthMain");
const showFourthMain = document.getElementById("anyFeadback");
//const fiveMain = document.getElementById("fiveMain");
const showFiveMain = document.getElementById("see-rules");

const sendFeadBack = document.getElementById("sendFeadBack");
const formForm = document.getElementById("message");
const errMessForm = document.getElementById("errMessForm");

const resetToMain = () => {
  firstFieldMain.classList.remove("classHide");
  thirdFieldMain?.classList.add("classHide");
  fourthMain?.classList.add("classHide");
  errMessForm.innerText = "";
  formForm.style.border = "none";
  WebApp?.BackButton.hide();
};

WebApp?.BackButton.onClick(resetToMain);

showFourthMain.addEventListener("click", () => {
  const getUrl = `/itemsMetrika?location=main-feedback&object=open_main_feedback&source=another&client_id=${clientYcId}`
  safeFetch(getUrl);
  WebApp?.BackButton.show?.();
  firstFieldMain.classList.add("classHide");
  fourthMain.classList.remove("classHide");
  formForm.value = "";
});

// showFiveMain.addEventListener("click", () => {
//   // const getUrl = `/itemsMetrika?location=main-feedback&object=open_main_feedback&source=another&client_id=${clientYcId}`
//   // safeFetch(getUrl);
//   WebApp.BackButton.show();
//   firstFieldMain.classList.add("classHide");
//   fiveMain.classList.remove("classHide");
// });

sendFeadBack.addEventListener("click", (e) => {
  const getUrl = `/itemsMetrika?location=main-feedback&object=send_main_feedback&source=another&client_id=${clientYcId}`
  safeFetch(getUrl);

  e.preventDefault();
  if (formForm.value.length < 1) {
    errMessForm.innerText = "Введите сообщение";
    formForm.style.border = "1px solid red";
    return;
  }

  errMessForm.innerText = "";
  formForm.style.border = "none";

  const formFeadback = document.getElementById("anyFeadbackForm");

  const newFrom = new FormData(formFeadback);
  const sendObject = {}
  newFrom.forEach((value, key) => {
    sendObject[key] = value;
  })

  showOverlay(displayPreloader, [fourthMain, getMainClass]);

  safeFetch("/upload", {
    method: "POST",
    headers: {
      "Content-type": "application/json",
    },
    body: JSON.stringify({
      type: "feedback_message",
      messege: sendObject,
      base64: "None",
      client: sendClient,
      botUser: botUser,
    })
  })
    .then((response) => response.text())
    .then((data) => {
      hideOverlay(displayPreloader, [fourthMain, getMainClass]);
      if (data === "success") {
        showAlert("Спасибо за отзыв!");
        document.getElementById("anyFeadbackForm").reset();
      }
    })
    .catch((error) => {
      hideOverlay(displayPreloader, [fourthMain, getMainClass]);
      console.error(error);
    });
})

autosize(document.getElementById("message"));
autosize(document.getElementById("textArea"));

const removeImg = () => {
  const removeAllImege = document.querySelectorAll(".removeImageDiv");
  if (removeAllImege != null) {
    for (let i = 0; i < removeAllImege.length; i++) {
      removeAllImege[i].remove();
    }
  }
}


const sendError = document.getElementById("sendError");
const showReferrerErrorBack = document.getElementById("referrerErrorBack");
const sendErrorBackBtn = document.getElementById("sendErrorBackBtn");
const textArea = document.getElementById("textArea");
const fileInput = document.getElementById("file");
const closeErrorBackButton = document.getElementById("closeErrorBackButton");
const showErr = document.getElementById("err");


sendError.addEventListener("click", () => {
  showReferrerErrorBack.style.display = "flex";

});


showReferrerErrorBack.addEventListener("click", (e) => {
  if (e.target.id == "referrerErrorBack") {
    showReferrerErrorBack.style.display = "none";
    textArea.value = "";
    fileInput.value = "";
    showErr.innerText = "";
    textArea.style.border = "none";
    removeImg();
  }
})

closeErrorBackButton.addEventListener("click", () => {
  showReferrerErrorBack.style.display = "none";
  textArea.value = "";
  fileInput.value = "";
  showErr.innerText = "";
  textArea.style.border = "none";

  removeImg();
})

const removeImageButton = () => {
  const removeImageDiv = document.querySelectorAll(".removeImageDiv");
  let removeImageButton = document.querySelectorAll(".removeImage");



  for (let i = 0; i < removeImageButton.length; i++) {

    removeImageButton[i].addEventListener("click", () => {
      removeImageDiv[i].remove();
    })

  }

}


let sendFiles = [];

function previewFiles() {

  const preview = document.querySelector(".input-file-list");
  const files = document.querySelector("input[type=file]").files;

  function readAndPreview(file) {
    // Проверяем, что `file.name` соответствует необходимым расширениям
    if (/\.(jpe?g|png|gif)$/i.test(file.name)) {
      const reader = new FileReader();
      reader.addEventListener("load", () => {

        const div = document.createElement("div");
        // const img = document.createElement("img");
        div.classList.add("removeImageDiv");
        // img.src = closeCrossRed;
        // img.style.height = "20px";
        // img.classList.add("removeImage");
        // div.appendChild(img);
        div.style.backgroundImage = `url(${reader.result})`;
        div.innerHTML = `<img src=${closeCrossRed} class="removeImage"/>`;
        div.id = file.name;
        // const image = new Image();
        // image.width = 170;
        // image.title = file.name;
        // image.src = reader.result;
        // // image.id = "needRemove";
        // image.classList.add("removeIt");
        // // div.appendChild(image);
        preview.appendChild(div);

      });

      reader.readAsDataURL(file);
    }
  }

  if (files) {
    Array.prototype.forEach.call(files, readAndPreview);

    setTimeout(() => {
      removeImageButton();
    }, 200)
  }

}

const picker = document.getElementById("file");
picker.addEventListener("change", previewFiles);

sendErrorBackBtn.addEventListener("click", (e) => {
  e.preventDefault();


  if (textArea.value.length <= 0) {
    showErr.innerText = "Обязательное поле";
    textArea.style.border = "1px solid red";
    return;
  }

  showOverlay(displayPreloader, [showReferrerErrorBack, getMainClass]);

  const allImg = document.querySelectorAll(".removeImageDiv");

  for (let i = 0; i < allImg.length; i++) {
    sendFiles[i] = { base: allImg[i].style.backgroundImage.split(",")[1], name: allImg[i].id }
  }

  // imgBase64.forEach((name, index) => {
  //   sendFiles[index] = { base: name, name: sssss[index].name };
  // });

  safeFetch("/upload", {
    method: "POST",
    headers: {
      "Content-type": "application/json",
    },
    body: JSON.stringify({
      type: "error_message",
      messege: textArea.value,
      base64: sendFiles,
      client: sendClient,
    })
  })
    .then((response) => response.text())
    .then((data) => {
      hideOverlay(displayPreloader, [showReferrerErrorBack, getMainClass]);
      if (data === "success") {
        showAlert("Спасибо!");
        // document.getElementById("anyFeadbackForm").reset();
        showReferrerErrorBack.style.display = "none";
        textArea.value = "";
        fileInput.value = "";
        removeImg();
        // imgBase64 = [];
        showErr.innerText = "";
        textArea.style.border = "none";
      } else {
        showAlert("Ошибка, попробуйте позднее");
      }


    })
    .catch((error) => {
      hideOverlay(displayPreloader, [showReferrerErrorBack, getMainClass]);
      console.error(error);
    });
})


const allLabel = document.querySelectorAll(".clickLabel");

for (let i = 0; i < allLabel.length; i++) {
  allLabel[i].addEventListener("click", () => {
    const getUrl = `/itemsMetrika?location=main-feedback&object=select_point&source=another&client_id=${clientYcId}`
    safeFetch(getUrl);
  })
}

// Установка ссылки на кнопку чата поддержки
const openTelegramChatButton = document.getElementById("openTelegramChat");
loadRuntimeConfig().then(() => {
  if (!openTelegramChatButton) return;
  const clientGroupId = localStorage.getItem("clientGroupId");
  if (clientGroupId && clientGroupId !== "n/a" && clientGroupId !== undefined && clientGroupId !== null) {
    const clientGroupIdWithoutSpaces = clientGroupId.replace(/\s/g, '');
    openTelegramChatButton.href = getSupportBotLink(clientGroupIdWithoutSpaces);
  } else {
    openTelegramChatButton.href = getSupportBotLink();
  }
});

if (openTelegramChatButton) {
  openTelegramChatButton.addEventListener("click", (e) => {
    e.preventDefault();
    openExternalLink(openTelegramChatButton.href);
  });
}